import {Box, Grid} from "@mui/material";
import React from "react";
import theme from "../../../theme/Theme";

export const GroupBox = (params) => {
    let arr = params?.data?.[params?.arrayName];

    return (
        <Grid container>
            {arr?.length && arr[0] !== null && arr.map(group => (
            <Box key={group} component="div" sx={{
                visibility: 'visible', fontSize: "11.67px", height: "24px", width: 'fit-content', maxWidth: params.colDef.width - 10,
                backgroundColor: theme.palette.artisticTags50.main, borderRadius: "7px", marginBottom: '3px', marginTop: '3px',
                display: 'flex', alignItems: "center", justifyContent:"center", marginRight: '3px', marginLeft: '3px'
            }}>
                <div style={{overflow: "hidden", textOverflow: "ellipsis", marginRight: '5px', marginLeft: '5px'}}>
                    {group}
                </div>
            </Box>
            ))}
        </Grid>
    );
};
